import React, {Component} from 'react'
import {connect} from "react-redux";
import {getOrderLimits} from "../../../../actions/order-limits";
import PageTitle from "../../../common/page-title";
import Datatable from "../../../common/datatable";
import {dateFormat} from "../../../../utils/commonFunctions";
import {history} from "../../../../store";

class OrderLimits extends Component {
  componentDidMount() {
    this.props.dispatch(getOrderLimits());
  }

  columns = [
    {
      prop: 'transaction-type',
      title: 'order limit type',
    },
    {
      prop: 'start-date',
      title: 'start date',
      width: '100',
      format(data, _) {
        return dateFormat(data)
      }
    },
    {
      prop: 'end-date',
      title: 'end date',
      width: '100',
      format(data, _) {
        return dateFormat(data)
      }
    },
    {
      prop: 'active',
      title: 'live?',
      width: '60',
      format(data, _) {
        return <div className='text-center'>{data ? 'yes' : 'no'}</div>
      }
    },
  ];

  actions = [
    {
      label: 'Edit',
      permissions: {
        action: 'manage',
        subjectClass: 'Order'
      },
      callback: (row) => {
        history.push(`/admin/order-limits/${row.id}/edit`);
      }
    }
  ];

  render() {
    const { orderLimits } = this.props;
    return (
      <div className="container-fluid">
        <PageTitle>Order Limits</PageTitle>
        <Datatable
          data={orderLimits || []}
          columns={this.columns}
          actions={this.actions}
          hideId={true}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orderLimits: state.orderLimits.orderLimits,
    fetching: state.orderLimits.fetching,
    fetched: state.orderLimits.fetched
  };
};

export default connect(mapStateToProps)(OrderLimits);


// WEBPACK FOOTER //
// ./src/components/admin/order-limits/list/index.jsx